import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { Contact, ContactType } from '../../types/contacts/contacts.type';
import { rejectWithApiError } from '../../utils/api';
import { RootReducerState } from '../../redux/Reducers';

// Create a new contact
export const createContact = createAsyncThunk<
  ContactType,
  { data: Contact },
  { state: RootReducerState; rejectValue: string }
>('contacts/createContact', async ({ data }, thunkAPI) => {
  try {
    const response = await axios.post<ContactType>(`${process.env.REACT_APP_API_URL}/contacts`, data);
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error creating contact!' });
  }
});

// Update contact details
export const updateContact = createAsyncThunk<
  Contact,
  { id: number; data: Partial<Contact> },
  { state: RootReducerState; rejectValue: string }
>('contacts/updateContact', async ({ id, data }, thunkAPI) => {
  try {
    const response = await axios.patch<Contact>(`${process.env.REACT_APP_API_URL}/contacts/${id}`, data);
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error updating contact!' });
  }
});

export const deleteContact = createAsyncThunk<
  Contact,
  { id: number },
  { state: RootReducerState; rejectValue: string }
>('contacts/deleteContact', async ({ id }, thunkAPI) => {
  try {
    const response = await axios.delete<Contact>(`${process.env.REACT_APP_API_URL}/contacts/${id}`);
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error deleting contact!' });
  }
});

// Fetch organization contacts
export const getOrganizationContacts = createAsyncThunk<
  { contacts: Contact[] },
  { organizationId: number },
  { state: RootReducerState; rejectValue: string }
>('contacts/getOrganizationContacts', async ({ organizationId }, thunkAPI) => {
  try {
    const response = await axios.get<{ contacts: Contact[] }>(
      `${process.env.REACT_APP_API_URL}/organizations/${organizationId}/contacts`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching organization contacts:', error);
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error fetching organization contacts!' });
  }
});

// Fetch location contacts
export const getLocationContacts = createAsyncThunk<
  { contacts: Contact[] },
  { locationId: number },
  { state: RootReducerState; rejectValue: string }
>('contacts/getLocationContacts', async ({ locationId }, thunkAPI) => {
  try {
    const response = await axios.get<{ contacts: Contact[] }>(
      `${process.env.REACT_APP_API_URL}/location/${locationId}/contacts`
    );
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error fetching location contacts!' });
  }
});
